import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { EasyClaimDocumentType } from 'src/easyclaim.api.client.typescript/src';
import { MemoPlaceholderScooterBackLeft } from 'src/easyclaim.app.assets/artwork/placeholder/v2/PlaceholderScooterBackLeft';
import { reportError } from 'src/easyclaim.app.libs/reportError';

import {
	DetailContainer,
	ExampleModalImage,
	ImageFileInputType,
	SelectImage,
	StyledInfoIcon,
} from '../../easyclaim.app.components/index';
import { Image } from '../../easyclaim.app.services/ImageSelectionService';
import { isAnyOfImagesLoading } from '../FourAdditionalPictures';
import { FourDiagonalPerspectivesProps } from '../FourDiagonalPerspectives';

export function ScooterBackLeftControl(currentAppState: FourDiagonalPerspectivesProps) {
	return (
		<>
			<h3 className="four-diagonal-perspectives-vehicle-rear-left-title">
				<FormattedMessage id="fourDiagonalPerspectives.vehicleRearLeft.title" />
				<StyledInfoIcon
					className="four-diagonal-perspectives-example-icon four-diagonal-perspectives-vehicle-rear-left-info-icon"
					onClick={() => {
						showExampleModal(currentAppState).catch(reportError);
					}}
				/>
			</h3>
			<DetailContainer>
				<SelectImage
					componentId="vehicleRearLeft"
					imageFileInputType={ImageFileInputType.CapturePicture}
					fileType={EasyClaimDocumentType.RearLeftPicture}
					caseId={currentAppState.easyClaimCase?.caseId}
					easyClaimService={currentAppState.easyClaimService}
					currentImage={currentAppState.vehicleImageRearLeft}
					title="vehicleImages.leftRearOverview"
					placeholder={<MemoPlaceholderScooterBackLeft className="photo-placeholder" />}
					marginBottom="1rem"
					onChange={(image) => {
						const newState = vehicleImageChanged(currentAppState, image);

						void currentAppState.setAppState(newState);
					}}
					onShowExample={() => {
						showExampleModal(currentAppState).catch(reportError);
					}}
					showUserFeedbackInfo={true}
					configuration={currentAppState.easyClaimCase!._configuration!}
					inputError={currentAppState.inputError}
					vehicleType={currentAppState.easyClaimCase?.vehicle?.vehicleTypeId}
				/>
			</DetailContainer>
		</>
	);
}

function vehicleImageChanged(currentAppState: AppState, image: Image | undefined): AppState {
	let images: Image[] = [];

	images = currentAppState.vehicleImageFrontLeft
		? images.concat([currentAppState.vehicleImageFrontLeft])
		: images;
	images = image ? images.concat([image]) : images;
	images = currentAppState.vehicleImageRearRight
		? images.concat([currentAppState.vehicleImageRearRight])
		: images;
	images = currentAppState.vehicleImageFrontRight
		? images.concat([currentAppState.vehicleImageFrontRight])
		: images;

	const isImageLoading = isAnyOfImagesLoading(images);

	const newState = Object.assign({}, currentAppState, {
		vehicleImageRearLeft: image,
		isImageLoading: isImageLoading,
	});

	return newState;
}

function showExampleModal(currentAppState: AppState) {
	const images: ExampleModalImage[] = [
		{ src: `${process.env.PUBLIC_URL}/images/example-policycheck-motorbike-back-left.png` },
	];

	return currentAppState.showExampleModal(
		images,
		'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle',
		'fourPerspectivesExampleModal.button.close',
		'rear-left-motorbike'
	);
}
